import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrRoutingCertaintyBand.ts
var t = () => e("routingCertaintyBand");
//#endregion
export { t as useTrRoutingCertaintyBand };
